<div class="container">
  <h1>Editar perfil</h1>
  <div class="spinner-container" *ngIf="!cargandoForm()">
    <mat-spinner diameter="35" strokeWidth="2"></mat-spinner>
  </div>
  <form [formGroup]="datosUsuariosService.usuarioActivoForm" id="formUsuarioActivo" *ngIf="cargandoForm()">
    <div>
      <label for="nombre">Nombre</label>
      <br>
      <input type="text" name="nombre" id="nombre" formControlName="nombre" [ngClass]="{'errorInput': datosUsuariosService.isCampoValido('nombre')}">
      <br>
      <span *ngIf="datosUsuariosService.isCampoValido('nombre')" class="texto-validacion" >El nombre es requerido.</span>
    </div>
    <div>
      <label for="apellidos">Apellidos</label>
      <br>
      <input type="text" name="apellido1" id="apellido1" formControlName="apellido1" [ngClass]="{'errorInput': datosUsuariosService.isCampoValido('apellido1')}">
      <br>
      <span *ngIf="datosUsuariosService.isCampoValido('apellido1')" class="texto-validacion" >El apellido es requerido.</span>
    </div>
    <div>
      <label for="email">E-mail</label>
      <br>
      <input type="email" name="email" id="email" formControlName="email" readonly>
    </div>
    <div *ngIf="datosUsuariosService.integracionA3">
      <label for="usuarioA3Trans">Usuario A3</label>
      <br>
      <input type="text" name="usuarioA3Trans" id="usuarioA3Trans" formControlName="usuarioA3Trans">
    </div>
    <div *ngIf="datosUsuariosService.integracionA3">
      <label for="passwordA3">Password A3</label>
      <br>
      <div class="password-container">
        <input [type]="hidePassword ? 'password' : 'text'" name="passwordA3" id="passwordA3" formControlName="passwordA3" autocomplete="new-password" [ngClass]="{'errorInput': datosUsuariosService.isCampoValido('passwordA3')}">
        <i class="fa"
           [ngClass]="hidePassword ? 'fa-eye-slash' : 'fa-eye'"
           (click)="togglePasswordVisibility()"></i>
      </div>
      <span *ngIf="datosUsuariosService.isCampoValido('passwordA3')" class="texto-validacion" >El password no debe contener más de 25 caracteres.</span>
    </div>
    <div style="margin-left: -10px;">
      <app-boton-accion [id]="'guardar cambios usuario activo'" [icono]="'hs-guardar'" [titulo]="'guardar'" [outline]="false" (click)="guardar()"></app-boton-accion>
    </div>
  </form>


</div>
